import { useCallback } from 'react';
import type { ElasticRetailer } from '@//app/api/retailers/[slug]';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import type { LegacyTrackMailVisibleRetailerEventData } from './legacy-types';
import { mapElasticBranchToLegacyItem } from './utils';

export const createLegacyTrackMailVisibleRetailer = (
  branch: ElasticRetailer,
): LegacyTrackMailVisibleRetailerEventData => {
  const eventData: LegacyTrackMailVisibleRetailerEventData = {
    eventType: 'conversion',
    conversionType: 'mail-visible-retailer',
    item: mapElasticBranchToLegacyItem(branch),
    pageType: 'dealer page',
  };

  return eventData;
};

export const useLegacyTrackMailVisibleRetailer = () => {
  const { track } = useLegacyTracking();

  const trackLegacyTrackMailVisibleRetailer = useCallback(
    (branch: ElasticRetailer) => {
      track({
        event: 'conversion',
        data: createLegacyTrackMailVisibleRetailer(branch),
      });
    },
    [track],
  );

  return {
    trackLegacyTrackMailVisibleRetailer,
  };
};
